import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useTimeout } from 'usehooks-ts';
const DELAY = 4000;
const useFakeSpinnerTimeout = () => {
  const $ = _c(1);
  const [show, setShow] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setShow(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useTimeout(t0, DELAY);
  return show;
};
export default useFakeSpinnerTimeout;